import producer from "immer";

const INITIAL_STATE = {
	loading: false,
	token: undefined,
	recoverFail: [],
	pinCodeFail: false,
	accountRecoverWithTypeResponse: [],
};

export default function recoverPassword(state = INITIAL_STATE, action) {
	const ACTIONS = {
		"@recover/CHANGE_LOADING": (draft) => {
			draft.loading = action.payload.loading;
		},
		"@recover/SEND_TOKEN": (draft) => {
			draft.token = action.payload.token;
		},
		"@recover/SHOW_MESSAGE_RECOVER_FAILED": (draft) => {
			draft.recoverFail = action.payload;
		},
		"@recover/RECOVER_PIN_CODE_FAILED": (draft) => {
			draft.pinCodeFail = action.payload.param;
		},
		"@recover/ACCOUNT_RECOVER_WITH_TYPE_RESPONSE": (draft) => {
			draft.accountRecoverWithTypeResponse = action.payload.data;
		},
	};

	return producer(state, (draft) => {
		return Object.keys(ACTIONS).indexOf(action.type) !== -1 ? ACTIONS[action.type](draft) : state;
	});
}
